import findParent from './findParent';

/**
 * Finds the first parent who's position is not static.
 * It will return the initial element if it is positioned.
 */
const findPositionedContainer = findParent(
  (el) => window.getComputedStyle(el).position !== 'static'
);

export default findPositionedContainer;
